import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { KhophieuAction } from 'src/actions/khophieu.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
  MAXIMUM_IMAGES,
} from 'src/utils/constants';
import { getKhophieuStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Button,
  Select as Select1,
  MenuItem,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import ExcelJS from 'exceljs';
import * as fs from 'fs';

import { Settings, Download, Upload, Cached } from '@material-ui/icons';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import KhophieuView from './KhophieuView';

const KhophieuLookupDetail = ({ ...rest }) => {
  const maximumImages = MAXIMUM_IMAGES;
  const dispatch = useDispatch()
  const [selectedKhophieuIds, setSelectedKhophieuIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { role } = useSelector(state => state.profile);
  const { items, total, filter, ton_hien_tai, ton_dau_ky, nhap_trong_ky, xuat_trong_ky, ton_cuoi_ky } = useSelector(state => state.khophieu);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const [openKhophieuView, setOpenKhophieuView] = useState(false);
  const [_khos, setKhos] = useState(null);
  const [_khophieu, setKhophieu] = useState(null);

  const trangThaiOptions = [
    { value: 'cho_duyet', label: 'Chờ duyệt' },
    { value: 'da_duyet', label: 'Đã duyệt' },
    { value: 'tu_choi', label: 'Từ chối' }
  ];

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(KhophieuAction.updateFilter(payload));
    dispatch(KhophieuAction.list(page, limit))
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedKhophieuIds;

    if (event.target.checked) {
      newSelectedKhophieuIds = items.map((khophieu) => khophieu.id);
    } else {
      newSelectedKhophieuIds = [];
    }

    setSelectedKhophieuIds(newSelectedKhophieuIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedKhophieuIds.indexOf(id);
    let newSelectedKhophieuIds = [];

    if (selectedIndex === -1) {
      newSelectedKhophieuIds = newSelectedKhophieuIds.concat(selectedKhophieuIds, id);
    } else if (selectedIndex === 0) {
      newSelectedKhophieuIds = newSelectedKhophieuIds.concat(selectedKhophieuIds.slice(1));
    } else if (selectedIndex === selectedKhophieuIds.length - 1) {
      newSelectedKhophieuIds = newSelectedKhophieuIds.concat(selectedKhophieuIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedKhophieuIds = newSelectedKhophieuIds.concat(
        selectedKhophieuIds.slice(0, selectedIndex),
        selectedKhophieuIds.slice(selectedIndex + 1)
      );
    }

    setSelectedKhophieuIds(newSelectedKhophieuIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, khophieu) => {
    setSelected(khophieu);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(KhophieuAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(KhophieuAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenKhophieuView = (khos, khophieu) => {
    dispatch(KhophieuAction.findOne(khophieu.id));
    setKhos(khos);
    setKhophieu(khophieu);
    setOpenKhophieuView(true);
  };

  const handleCloseKhophieuView = () => {
    setOpenKhophieuView(false);
  };

  const approve = async (id, trang_thai_duyet) => {
    const question = trang_thai_duyet == 1 ? "Xác nhận duyệt đơn này?" : "Xác nhận từ chối đơn này?" ;
    if (window.confirm(question)) {
      try {
        const response = await dispatch(KhophieuAction.approve(id, { trang_thai_duyet }));
        if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
        else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
      } catch (error) {
        if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
      }
    } else {
      
    }
  };

  const setTrangThai = async (khophieu, trang_thai, trang_thai_text) => {
    if (!(typeof khophieu.khos !== 'undefined' && khophieu.khos && khophieu.khos.length > 0)) {
      alert("Phiếu này hiện tại chưa có sản phẩm nào. Không thể thay đổi sang trạng thái '" + trang_thai_text + "'");
      return;
    }

    const id = khophieu.id;
    const question = "Xác nhận đặt trạng thái '" + trang_thai_text + "'?";
    if (window.confirm(question)) {
      try {
        // const response = await dispatch(KhophieuAction.setTrangThai(id, { trang_thai }));
        // if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
        // else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
        
          dispatch(KhophieuAction.update(id, { 
          trang_thai,
        }))
      } catch (error) {
        if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
      }
    } else {
      
    }
  };

  const exportExcelOne = async(khophieu) => {
    khophieu = await dispatch(KhophieuAction.findOne(khophieu.id));

    if (khophieu && khophieu.data) {
      console.log(khophieu.data);

      if (khophieu.data.loai_phieu == 'xuat_kho') {
        exportExcelPhieuXuatKho(khophieu.data);
      }
    }
  }

  const exportExcelPhieuXuatKho = async(khophieu) => {
    try {
      // 1) tải template (đặt template.xlsx vào public/)
      const res = await fetch('/static/template_phieu_xuat_kho.xlsx');
      if (!res.ok) throw new Error(`Không tìm thấy template - trạng thái lỗi ${res.status}`);
      const arrayBuffer = await res.arrayBuffer();
  
      // 2) đọc workbook (chờ load xong)
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);
  
      // debug: in ra tên sheet để chắc chắn workbook đã có sheet
      console.log('Worksheets loaded:', workbook.worksheets.map(ws => ws.name));
      if (!workbook.worksheets || workbook.worksheets.length === 0) {
        throw new Error('Template không chứa sheet nào (workbook.worksheets.length === 0)');
      }
  
      // 3) lấy sheet an toàn: ưu tiên sheet đầu tiên
      const sheet = workbook.getWorksheet(1) || workbook.worksheets[0] || workbook.getWorksheet('Sheet1');
      if (!sheet) throw new Error('Không tìm thấy sheet trong template (tên/idx không đúng)');
  
      // 4) ghi dữ liệu (ví dụ)
      // Ghi theo address (A1, B2...) hoặc row/col
      sheet.getCell('E4').value = parseDate(khophieu.createdAt);
      sheet.getCell('G5').value = khophieu.so_phieu;
      sheet.getCell('D9').value = khophieu.ho_ten_nguoi_nhan + ' - ' + khophieu.sdt_nguoi_nhan;
      sheet.getCell('D10').value = khophieu.dia_chi_giao;
      sheet.getCell('D11').value = khophieu.ly_do;
      sheet.getCell('D12').value = khophieu.ten_kho_xuat;
      sheet.getCell('G12').value = khophieu.dia_diem_kho_xuat;

      let demSoLuong = 0;
      let tongThanhTien = 0;

      if (khophieu.khos && khophieu.khos.length > 0) {
        for (let i = 0; i < khophieu.khos.length; i++) {
          let kho = khophieu.khos[i];

          // const cellTenSanPham = sheet.getCell('C' + (i + 17));
          // cellTenSanPham.value = kho.ten_san_pham_text + '\n' + kho.phien_ban_san_pham_text + (kho.thong_tin_them.trim() != '' ? '\n' + kho.thong_tin_them.trim() : '');
          // cellTenSanPham.alignment = { wrapText: true };

          sheet.getRow(i + 17).height = 100;
          sheet.mergeCells('C' + (i + 17) + ':D' + (i + 17));

          sheet.getCell('B' + (i + 17)).value = i + 1;
          sheet.getCell('C' + (i + 17)).value = kho.ten_san_pham_text + '\n' + kho.phien_ban_san_pham_text + (kho.thong_tin_them.trim() != '' ? '\n' + kho.thong_tin_them.trim() : '');
          sheet.getCell('E' + (i + 17)).value = kho.ma_san_pham;
          sheet.getCell('G' + (i + 17)).value = '';

          let cellSoLuong = sheet.getCell('F' + (i + 17));
          cellSoLuong.value = Math.abs(Number(kho.nhap_xuat));
          cellSoLuong.numFmt = '#,##0';

          let cellDonGia = sheet.getCell('H' + (i + 17));
          cellDonGia.value = Number(kho.don_gia);
          cellDonGia.numFmt = '#,##0';

          let cellThanhTien = sheet.getCell('I' + (i + 17));
          cellThanhTien.value = Number(kho.don_gia) * Math.abs(Number(kho.nhap_xuat));
          cellThanhTien.numFmt = '#,##0';

          demSoLuong += Math.abs(Number(kho.nhap_xuat));
          tongThanhTien += Number(kho.don_gia) * Math.abs(Number(kho.nhap_xuat));
        }

        console.log('C' + (khophieu.khos.length + 17));

        sheet.getCell('F' + (khophieu.khos.length + 17)).numFmt = '#,##0'; 
        sheet.getCell('I' + (khophieu.khos.length + 17)).numFmt = '#,##0'; 

        sheet.mergeCells('C' + (khophieu.khos.length + 17) + ':D' + (khophieu.khos.length + 17));

        const cellCong = sheet.getCell('C' + (khophieu.khos.length + 17));
        cellCong.value = "Cộng";
        cellCong.style = { ...cellCong.style, font: { name: 'Times New Roman', size: 11, bold: true } };

        sheet.getCell('E' + (khophieu.khos.length + 17)).value = 'x';
        sheet.getCell('F' + (khophieu.khos.length + 17)).value = demSoLuong;
        sheet.getCell('G' + (khophieu.khos.length + 17)).value = '-';
        sheet.getCell('H' + (khophieu.khos.length + 17)).value = 'x';

        const cellTongThanhTien = sheet.getCell('I' + (khophieu.khos.length + 17));
        cellTongThanhTien.value = tongThanhTien;
        cellTongThanhTien.style = { ...cellTongThanhTien.style, font: { name: 'Times New Roman', size: 11, bold: true } };

        const startRow = 14;
        const endRow = khophieu.khos.length + 17; // vd = 19
        const startCol = 2; // B
        const endCol = 9;   // I

        // 1) tạo/đặt border cho đúng vùng B14:I(endRow)
        for (let r = startRow; r <= endRow; r++) {
          for (let c = startCol; c <= endCol; c++) {
            const cell = sheet.getCell(r, c);
            // set border (tạo ô trong vùng này thôi)
            cell.border = {
              top:    { style: 'thin', color: { argb: 'FF000000' } },
              left:   { style: 'thin', color: { argb: 'FF000000' } },
              bottom: { style: 'thin', color: { argb: 'FF000000' } },
              right:  { style: 'thin', color: { argb: 'FF000000' } },
            };
          }
        }

        // 2) CLEANUP: xóa các hàng TRỐNG phía dưới endRow để tránh !ref mở rộng
        // (Chỉ xóa row r nếu r > endRow và row không có ô nào chứa value)
        for (let r = sheet.rowCount; r > endRow; r--) {
          const row = sheet.getRow(r);
          let hasVal = false;
          row.eachCell({ includeEmpty: false }, (cell) => {
            if (cell.value !== null && cell.value !== undefined && cell.value !== '') {
              hasVal = true;
            }
          });
          if (!hasVal) {
            // remove the empty row so sheet range shrinks
            sheet.spliceRows(r, 1);
          } else {
            break; // gặp hàng có dữ liệu -> dừng
          }
        }

        sheet.mergeCells('D' + (khophieu.khos.length + 20) + ':F' + (khophieu.khos.length + 20));
        sheet.mergeCells('H' + (khophieu.khos.length + 20) + ':I' + (khophieu.khos.length + 20));
        sheet.mergeCells('H' + (khophieu.khos.length + 28) + ':I' + (khophieu.khos.length + 28));

        const cellNguoiLapPhieu = sheet.getCell('C' + (khophieu.khos.length + 20));
        cellNguoiLapPhieu.value = "NGƯỜI LẬP PHIẾU";
        cellNguoiLapPhieu.style = {
          ...cellCong.style,
          font: { name: 'Times New Roman', size: 11, bold: true },
          border: { // Xóa hết border
            top: { style: 'none' },
            left: { style: 'none' },
            bottom: { style: 'none' },
            right: { style: 'none' }
          },
          alignment: { vertical: 'middle', horizontal: 'center' } // Căn giữa cả dọc và ngang
        };

        const cellNguoiGiaoHang = sheet.getCell('D' + (khophieu.khos.length + 20));
        cellNguoiGiaoHang.value = "NGƯỜI GIAO HÀNG";
        cellNguoiGiaoHang.style = {
          ...cellCong.style,
          font: { name: 'Times New Roman', size: 11, bold: true },
          border: { // Xóa hết border
            top: { style: 'none' },
            left: { style: 'none' },
            bottom: { style: 'none' },
            right: { style: 'none' }
          },
          alignment: { vertical: 'middle', horizontal: 'center' } // Căn giữa cả dọc và ngang
        };

        const cellThuKho = sheet.getCell('G' + (khophieu.khos.length + 20));
        cellThuKho.value = "THỦ KHO";
        cellThuKho.style = {
          ...cellCong.style,
          font: { name: 'Times New Roman', size: 11, bold: true },
          border: { // Xóa hết border
            top: { style: 'none' },
            left: { style: 'none' },
            bottom: { style: 'none' },
            right: { style: 'none' }
          },
          alignment: { vertical: 'middle', horizontal: 'center' } // Căn giữa cả dọc và ngang
        };

        const cellNguoiNhan = sheet.getCell('H' + (khophieu.khos.length + 20));
        cellNguoiNhan.value = "NGƯỜI NHẬN";
        cellNguoiNhan.style = {
          ...cellCong.style,
          font: { name: 'Times New Roman', size: 11, bold: true },
          border: { // Xóa hết border
            top: { style: 'none' },
            left: { style: 'none' },
            bottom: { style: 'none' },
            right: { style: 'none' }
          },
          alignment: { vertical: 'middle', horizontal: 'center' } // Căn giữa cả dọc và ngang
        };

        const cellNguoiNhanChuKy = sheet.getCell('H' + (khophieu.khos.length + 28));
        cellNguoiNhanChuKy.value = khophieu.ho_ten_nguoi_nhan + ' - ' + khophieu.sdt_nguoi_nhan;
        cellNguoiNhanChuKy.style = {
          ...cellCong.style,
          font: { name: 'Times New Roman', size: 11, bold: true },
          border: { // Xóa hết border
            top: { style: 'none' },
            left: { style: 'none' },
            bottom: { style: 'none' },
            right: { style: 'none' }
          },
          alignment: { vertical: 'middle', horizontal: 'center' } // Căn giữa cả dọc và ngang
        };
      }

      // 5) xuất file
      const buf = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, khophieu.so_phieu + '.xlsx');
  
      console.log('Export xong');
    } catch (err) {
      console.error('exportFromTemplate error:', err);
      alert(err.message || 'Lỗi khi xuất file');
    }
  }

  const parseDate = (datetime) => {
    const dateString = datetime;
    const date = new Date(dateString);

    // Lấy ngày, tháng, năm
    const day = date.getDate();
    const month = date.getMonth() + 1; // tháng bắt đầu từ 0
    const year = date.getFullYear();

    // Hiển thị theo định dạng bạn muốn
    const formattedDate = `Ngày ${day} tháng ${month} năm ${year}`;

    return formattedDate;
  }

  const copyToClipboard = (content) => {
    navigator.clipboard
      .writeText(content)
      .then(() => {
        console.log('String copied to clipboard:', content);
        // showToast('success', `Đã copy: ${content}`);
      })
      .catch((error) => {
        console.error('Unable to copy string:', error);
        // showToast('error', `Lỗi không thể copy: ${content}`);
      });
  };

  const setColor = (value) => {
      if (value == 'cho_duyet') return 'orange';
      else if (value == 'da_duyet') return 'green';
      else if (value == 'tu_choi') return 'red';
      else if (value == 'positive') return 'green';
      else if (value == 'negative') return 'red';
      else return '#000000';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Loại phiếu
                </TableCell>
                <TableCell>
                  Số phiếu
                </TableCell>
                <TableCell>
                  Thông tin người nhận
                </TableCell>
                <TableCell>
                  Lý do
                </TableCell>
                <TableCell>
                  Kho xuất
                </TableCell>
                <TableCell>
                  Ghi chú
                </TableCell>
                <TableCell>
                  Ngày tạo
                </TableCell>
                <TableCell>
                  Người nhập
                </TableCell>
                <TableCell>
                  Người cập nhật cuối
                </TableCell>
                <TableCell>
                  Người duyệt
                </TableCell>
                <TableCell>
                  Trạng thái
                </TableCell>
                <TableCell>
                  Thao tác
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((khophieu, index) => (
                <TableRow
                  hover
                  key={khophieu.id}
                  selected={selectedKhophieuIds.indexOf(khophieu.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {khophieu.loai_phieu == "nhap_kho" && <span style={{ }}>Nhập kho</span>}
                      {khophieu.loai_phieu == "xuat_kho" && <span style={{ }}>Xuất kho</span>}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      <Button
                        style={{ padding: 0 }}
                        onClick={() =>
                          handleOpenKhophieuView(khophieu.khos, khophieu)
                        }
                      >
                        {khophieu.so_phieu}
                      </Button>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={() =>
                          copyToClipboard(khophieu.so_phieu)
                        }
                        style={{height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'orange', fontWeight: 'normal', fontSize: '20px'}}
                      >
                        {<ContentCopyIcon style={{ color: "white" }} />}
                      </Button>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      <span style={{fontWeight: 'bold'}}>- Tên:</span> {khophieu.ho_ten_nguoi_nhan}
                      <br></br>
                      <span style={{fontWeight: 'bold'}}>- SĐT:</span> {khophieu.sdt_nguoi_nhan}
                      <br></br>
                      <span style={{fontWeight: 'bold'}}>- Địa chỉ:</span> {khophieu.dia_chi_giao}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {khophieu.ly_do}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      <span style={{fontWeight: 'bold'}}>- Tên kho:</span> {khophieu.ten_kho_xuat}
                      <br></br>
                      <span style={{fontWeight: 'bold'}}>- Địa điểm:</span> {khophieu.dia_diem_kho_xuat}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {khophieu.ghi_chu}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {moment(khophieu.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {khophieu.username_nguoi_nhap}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {khophieu.username_chinh_sua_cuoi_cung}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {khophieu.username_nguoi_duyet}
                      <br></br>
											{khophieu.thoi_diem_duyet ? '(' + moment(khophieu.thoi_diem_duyet).format('DD-MM-YYYY HH:mm:ss') + ')' : ''}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color=""
                      variant="body1"
                    >
                      {role.priority < 3 && khophieu.trang_thai == 'cho_duyet' ? <>
                        <Select1
                          style={{
                            fontSize: '14px',
                            width: '120px',
                            marginBottom: '15px',
                            color: setColor(khophieu.trang_thai)
                          }}
                          variant="outlined"
                          value={khophieu.trang_thai}
                          onChange={(e) => {
                            const value = e.target.value;
                            const text = trangThaiOptions.find(opt => opt.value === value)?.label || '';
                            setTrangThai(khophieu, value, text);
                          }}
                        >
                          {trangThaiOptions.map((opt) => (
                            <MenuItem
                              key={opt.value}
                              value={opt.value}
                              style={{ color: setColor(opt.value) }}
                            >
                              {opt.label}
                            </MenuItem>
                          ))}
                        </Select1>
                      </> : <>
                        {khophieu.trang_thai == "cho_duyet" && <span style={{ color: setColor('cho_duyet'), paddingLeft: 5 }}>Chờ duyệt</span>}
                        {khophieu.trang_thai == "da_duyet" && <span style={{ color: setColor('da_duyet'), paddingLeft: 5 }}>Đã duyệt</span>}
                        {khophieu.trang_thai == "tu_choi" && <span style={{ color: setColor('tu_choi'), paddingLeft: 5 }}>Từ chối</span>}
                      </>}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton aria-label="export" onClick={() => exportExcelOne(khophieu)}>
                      <Download style={{ color: "#3498db", width: '24px', height: '24px' }} />
                    </IconButton>
                    {khophieu.trang_thai == "cho_duyet" && <IconButton aria-label="edit" onClick={() => onSelected(khophieu.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>}
                    {role.priority < 3 && <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, khophieu)}>
                      <Trash2Icon color='red' />
                    </IconButton>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <KhophieuView open={openKhophieuView} handleClose={handleCloseKhophieuView} khos={_khos} khophieu={_khophieu} />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_phieu} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default KhophieuLookupDetail;
